export const DELIVERY_INFORMATION_MODE_OF_TRANSPORTATIONS: { [key: string]: string } = {
    PARCEL: 'parcel',
    OCEAN: 'ocean',
    SEA: 'ocean',
    FLIGHT: 'flight',
    AIR: 'flight',
    RAIL: 'rail',
    TRUCK: 'truck',
    ROAD: 'truck',
    INTERMODAL: 'intermodal',
    BARGE: 'barge',
    FLAG: 'flag'
};

export const DELIVERY_INFORMATION_LEG_TYPES: { [key: string]: string } = {
    PreCarriage: 'PC',
    MainCarriage: 'MC',
    OnCarriage: 'ON'
};

export const DELIVERY_INFORMATION_LEG_STATES: { [key: string]: string } = {
    Ordered: 'Ordered',
    Planned: 'Planned',
    Active: 'Active',
    Confirmed: 'Confirmed',
    Completed: 'Complete',
    Complete: 'Completed'
};

export const DELIVERY_INFORMATION_PROGRESS_BAR_OFFSET_X = '10%';
export const DELIVERY_INFORMATION_PROGRESS_BAR_OFFSET_FULL = '20%';
